var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#MessageIcon_svg__clip0_3416_3802)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.667 13.75h1.667v1.667H1.667V13.75h1.667V7.917a6.667 6.667 0 0113.333 0v5.833zm-1.667 0V7.917a5 5 0 00-10 0v5.833h10zm-7.5 3.333h5v1.667h-5v-1.667z",
    fill: "#222B40"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "MessageIcon_svg__clip0_3416_3802"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}
export default SvgMessageIcon;